export default __webpack_public_path__ + "static/media/banner_shape.2822fcb8.png";